import CreateEditSpecialJob from './subdomains/SpecialJobsOverview/CreateEditSpecialJob';
import { EinmalauftraegeList } from './subdomains/EinmalauftraegeOverview';
import EinmalAuftragForm from './subdomains/EinmalauftraegeOverview/EinmalAuftragForm';
import { CreateEditProjectScreen } from './subdomains/ProjectOverview/CreateEditProject';
import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from 'react-router-dom';
import { useAuthenticationService } from './common/services/AuthenticationService';
import { CreateEditJobScreen } from './subdomains/ProjectOverview/CreateEditJob';
import CreateEditRoutine from './subdomains/RoutineOverview/CreateEditRoutine';
import { DepartmentScreen } from './subdomains/DepartmentOverview/Department';
import { SpecialJobs } from './subdomains/SpecialJobsOverview/SpecialJobs';
import { Wrapper } from './common/components/defaultUIComponents/Wrapper';
import { CreateOrdersV3 } from './subdomains/OrdersOverview/CreateOrders';
import { ProjectsScreen } from './subdomains/ProjectOverview/AllProjects';
import { ProjectScreen } from './subdomains/ProjectOverview/Project';
import Settings from './subdomains/CompanySettings/Settings';
import Routines from './subdomains/RoutineOverview/Routines';
import { TimeTracking } from './subdomains/CalenderOverview';
import { Orders } from '~/subdomains/OrdersOverview/Orders';
import { EmployeesV2 } from './subdomains/EmployeeOverview';
import Dayplan from '~/subdomains/DayplanOverview/Dayplan';
import Authenticate from './subdomains/Login/Authenticate';
import Dashboard from './subdomains/Dashboard/Dashboard';
import Analysis from './subdomains/Analysis/Analysis';
import routes from './common/constants/routes.json';

const mainRouter = createBrowserRouter(
  [
    {
      id: 'wrapper',
      element: <Wrapper />,
      children: [
        {
          path: routes.DASHBOARD,
          element: <Dashboard />,
        },
        {
          path: routes.USERS,
          element: <EmployeesV2 />,
        },
        {
          path: routes.USERS_V2,
          element: <EmployeesV2 />,
        },
        {
          path: routes.DEPARTMENTS,
          element: <DepartmentScreen />,
        },
        {
          path: routes.CREATE_JOB,
          element: <CreateEditJobScreen />,
        },
        {
          path: routes.EDIT_JOB,
          element: <CreateEditJobScreen />,
        },
        {
          path: routes.ORDERS_V3,
          element: <Orders />,
        },
        {
          path: routes.CREATE_ORDER_V2,
          element: <CreateOrdersV3 />,
        },
        {
          path: routes.SETTINGS,
          element: <Settings />,
        },
        {
          path: routes.DAYPLAN,
          element: <Dayplan />,
        },
        {
          path: routes.ROUTINES,
          element: <Routines />,
        },
        {
          path: routes.CREATE_ROUTINE,
          element: <CreateEditRoutine />,
        },
        {
          path: routes.EDIT_ROUTINE,
          element: <CreateEditRoutine />,
        },
        {
          path: routes.SPECIAL_JOBS,
          element: <SpecialJobs />,
        },
        {
          path: routes.CREATE_SPECIAL_JOB,
          element: <CreateEditSpecialJob />,
        },
        {
          path: routes.EDIT_SPECIAL_JOBS,
          element: <CreateEditSpecialJob />,
        },
        {
          path: routes.TIME_TACKING,
          element: <TimeTracking />,
        },
        {
          path: routes.TIME_TACKING_V2,
          element: <TimeTracking />,
        },
        {
          path: routes.PROJECTS_V2,
          element: <ProjectsScreen />,
        },
        {
          path: routes.PROJECTS,
          element: <ProjectsScreen />,
        },
        {
          path: routes.PROJECT,
          element: <ProjectScreen />,
        },
        {
          path: routes.CREATE_PROJECT,
          element: <CreateEditProjectScreen />,
        },
        {
          path: routes.EDIT_PROJECT,
          element: <CreateEditProjectScreen />,
        },
        {
          path: routes.ANALYSIS,
          element: <Analysis />,
        },
        {
          path: routes.EINMAL_AUFTRAEGE,
          element: <EinmalauftraegeList />,
        },
        {
          path: routes.CREATE_EINMAL_AUFTRAG,
          element: <EinmalAuftragForm />,
        },
        {
          path: routes.EDIT_EINMAL_AUFTRAG,
          element: <EinmalAuftragForm />,
        },
        {
          path: '*',
          loader: () => redirect(routes.DASHBOARD),
        },
      ],
    },
    {
      path: '*',
      loader: () => redirect(routes.DASHBOARD),
    },
  ],
  {},
);

const createUnauthedRouter = createBrowserRouter([
  {
    id: 'wrapper',
    element: <Wrapper header={false} />,
    children: [{ path: '*', element: <Authenticate /> }],
  },
]);

export default function Routes() {
  const { authenticationState } = useAuthenticationService();
  const authenticated = !!authenticationState?.token;
  if (authenticated) {
    return <RouterProvider router={mainRouter} />;
  }
  return <RouterProvider router={createUnauthedRouter} />;
}
